import makeService from './api';

export default makeService('nozzle_visuals');
